import PropTypes from 'prop-types';
import React, { useReducer } from 'react';

import FiltroActionTypes from './actions';
import { FiltroContext } from './hooks/useFiltro';
import { FILTRO_INICIAL, filtroReducer } from './reducer';

export function FiltroProvider({ children }) {
  const [filtro, dispatchFiltroAction] = useReducer(
    filtroReducer,
    FILTRO_INICIAL
  );

  function setDatePicker(payload) {
    dispatchFiltroAction({
      type: FiltroActionTypes.SET_DATE_PICKER,
      payload,
    });
  }

  function setFiltroOntem() {
    dispatchFiltroAction({
      type: FiltroActionTypes.SET_ONTEM,
    });
  }

  function setFiltroHoje() {
    dispatchFiltroAction({
      type: FiltroActionTypes.SET_HOJE,
    });
  }

  function setFiltroAmanha() {
    dispatchFiltroAction({
      type: FiltroActionTypes.SET_AMANHA,
    });
  }

  function setFieldDrawer(payload) {
    dispatchFiltroAction({
      type: FiltroActionTypes.SET_FIELD_DRAWER,
      payload,
    });
  }

  function clearFiltro() {
    dispatchFiltroAction({
      type: FiltroActionTypes.CLEAR_FILTRO_DRAWER,
    });
  }

  function fetchFiltro(payload) {
    dispatchFiltroAction({
      type: FiltroActionTypes.FETCH_FILTRO_DATA,
      payload,
    });
  }

  return (
    <FiltroContext.Provider
      value={{
        filtro,
        setDatePicker,
        setFiltroAmanha,
        setFiltroHoje,
        setFiltroOntem,
        clearFiltro,
        setFieldDrawer,
        fetchFiltro,
      }}
    >
      {children}
    </FiltroContext.Provider>
  );
}

FiltroProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

FiltroContext.displayName = 'FiltroContext';
